<template>
  <v-layout row wrap>
    <v-flex xs12 justify-center>
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab v-for="(tabItem, index) in tabItems" :key="'tab-' + index"> {{ tabItem.title }} </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(tabItem, index) in tabItems" :key="'tabItem-' + index">
          <keep-alive>
            <component :is="tabItem.component" :key="componentKey" @rerender="rerender" @research="$listeners['research']" />
          </keep-alive>
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
  </v-layout>
</template>

<script>
import GroupSearchResultComponent from "../components/GroupSearchResult";
import UserSearchResultComponent from "../components/UserSearchResult";

export default {
  name: "JobIndex",

  components: {
    GroupSearchResultComponent,
    UserSearchResultComponent
  },

  data: () => ({
    componentKey: 0,
    tab: null,
    tabItems: [
      { title: "グループ", component: GroupSearchResultComponent },
      { title: "ユーザー", component: UserSearchResultComponent },
    ],
  }),

  methods: {
    rerender() {
      this.componentKey++;
    },
  },
};
</script>
